import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import { PathwayStateType_Admit, PathwayStateType_Discharge } from '@app/pathway-shared';
import { ModuleFE_Advisor_PathwayState, ModuleFE_EMInterface, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { Advisor_DialogConfirmation } from '../../components/Advisor_DialogConfirmation/Advisor_DialogConfirmation.js';
import { capitalizeAllFirstLetters, exists, sortArray } from '@nu-art/ts-common';
import './PopUp_ProtocolGoTo.scss';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { ModuleFE_ProvideInfo } from '../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { ICONS } from '@app/styles';
import { contextCloseMode_Force } from '../../../modules/provide-info/types.js';
export class PopUp_ProtocolGoTo extends ComponentSync {
    //######################### Static ##########################
    static show = (e, props) => {
        // @ts-ignore - Don't know why TS says getBoundingClientRect doesn't exist here, it does
        const rect = e.target.getBoundingClientRect();
        const model = {
            content: () => _jsx(PopUp_ProtocolGoTo, { ...props }),
            id: 'pop-up__protocol-go-to',
            modalPos: { x: -1, y: -1 },
            originPos: { x: rect.right, y: rect.top },
            xAxisAnchor: 'right',
            yAxisAnchor: 'bottom',
            offset: { y: 10 },
            overlayClass: 'pop-up-overlay__protocol-go-to'
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Life Cycle ##########################
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        const activeStateId = ModuleFE_RuntimeProtocol.getProtocolActiveState(state.protocolData.protocol);
        state.states = sortArray(ModuleFE_Advisor_PathwayState.cache.filter(ps => ps._id !== activeStateId && ps.pathwayIds.includes(state.protocolData.pathway._id)), state => state.name.toLowerCase());
        return state;
    }
    //######################### Logic ##########################
    onStateClick = (state) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        const protocolData = this.state.protocolData;
        //Report analytics event
        ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_open({
            method: 'button',
            protocolId: protocolData.protocol._id,
            protocolLabel: protocolData.pathway.label
        });
        Advisor_DialogConfirmation.show({
            confirmCallback: async () => {
                try {
                    await ModuleFE_EMInterface.vv1.navigator.goToState({
                        protocolId: this.state.protocolData.protocol._id,
                        targetState: state._id,
                    }).executeSync();
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_submit();
                    if (ModuleFE_AdvisorMini.getIsMiniActive())
                        return ModuleFE_ProvideInfo.refreshProtocolContextData();
                    ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Force);
                    ModuleFE_ProvideInfo.protocol.open(protocolData.protocol._id);
                }
                catch (err) {
                    this.logError(`Failed going to state ${err}`);
                }
            },
            cancelCallback: () => {
                //Report analytics event
                ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_abandon();
            },
            content: () => _jsxs(_Fragment, { children: ['Are you sure you want to jump to ', _jsxs("span", { style: { fontWeight: '600', fontSize: '15px' }, children: [capitalizeAllFirstLetters(state.name), "?"] })] }),
            confirmButtonLabel: 'Jump'
        });
    };
    //######################### Render ##########################
    render() {
        return _jsx(_Fragment, { children: this.state.states.map(state => {
                const Icon = ![PathwayStateType_Admit, PathwayStateType_Discharge].includes(state.type)
                    ? undefined
                    : state.type === PathwayStateType_Admit
                        ? ICONS.advisor_avn_admit : ICONS.advisor_avn_discharge;
                return _jsxs("div", { onClick: () => this.onStateClick(state), children: [exists(Icon) && _jsx(Icon.component, {}), " ", state.name] }, state._id);
            }) });
    }
}
//# sourceMappingURL=PopUp_ProtocolGoTo.js.map